export const normalize = (dateStr) => {
    const d = new Date(dateStr);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

/**
 * Headers for browser-managed multipart requests.
 * Do not set Content-Type here: the browser must add the multipart boundary.
 */
export const createMultipartAuthHeaders = (token) => ({
    Authorization: `Bearer ${token}`,
});
